import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Hero from "../Hero";
import HomeAbout from "../HomeAbout";
import HomeSolution from "../HomeSolution";
import HomeFinancialCrime from "../HomeFinancialCrime";
import HomeIndustries from "../HomeIndustries";
import HomeWhyChoose from "../HomeWhyChoose";



const Home = () => {

    return (
        <>
            <Header />
            <Hero />
            <HomeAbout/>
            <HomeSolution/>
            <HomeFinancialCrime/>
            <HomeIndustries/>
            <HomeWhyChoose/>
            <Footer />
        </>
    );
};

export default Home;